/* unplugin-vue-components disabled */import { render } from "./HistoryComponent.vue?vue&type=template&id=52dcaa6c&scoped=true"
import script from "./HistoryComponent.vue?vue&type=script&lang=js"
export * from "./HistoryComponent.vue?vue&type=script&lang=js"

import "./HistoryComponent.vue?vue&type=style&index=0&id=52dcaa6c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dcaa6c"]])

export default __exports__